// import React, { useEffect, useState } from "react";
// import instance from "../../api/api";
// import InputCreate from "../../features/InputCreate";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// // import { useNavigate } from "react-router-dom";
// import Button from "../../features/Button";
// // import { FaArrowLeft } from "react-icons/fa";
// // import { MultiSelect } from "primereact/multiselect";
// import { LoadingSpinner, Header } from "../../shared/compoments";
// import { Upload } from "antd";
// import PrintModalContrat from "./feature/PrintContrat";

// import { useDispatch } from "react-redux";
// import { handleTogglePrintContrat } from "../../store/slice/contrat/Contrat.js";

// // import SlideCommission from "./feature/SlideCommission"

// function CreateContrat() {
//   // const navigate = useNavigate();
//   // const dispatch = useDispatch();

//   const styleBtn = {
//     padding: ".5em",
//     borderRadius: "5px",
//     fontWeight: "bold",
//     cursor: "pointer",
//     color: "black",
//     backgroundColor: "rgb(255 177 47 / 99%)",
//     marginTop: "1em",
//     border: "none",
//   };
//   const MySwal = withReactContent(Swal);

//   const [data, setData] = useState({
//     nom: "",
//     prenom: "",
//     role_id: 3,
//     email: "",
//     phone: "",
//     password: "00000",
//     client_id: "",
//     proprietaire_id: "",
//     nombre_mois_caution: "",
//     nombre_mois_avance: "",
//     propriety_id: "",
//     propriety_libelle: "",
//     date_entree: "",
//     date_sortie: "",
//     commission_structure: false,
//     is_commission_apporter_affaire: false,
//     // introducer_type:"",
//     frequence_paiement: "mois",
//     propriety_type_transaction: "",
//     commission_introducteur: "",
//     project_percentage: "",
//     commission_montant_terrain_km2: "",
//   });
//   const [fileList, setFileList] = useState([]);

//   const onChangeForGalerie = ({ fileList: newFileList }) => {
//     setFileList(newFileList);
//     const newTableau = convertirGalerie(newFileList);
//     console.log("newTableau", newTableau);
//   };
//   const convertirGalerie = (tableauImage) => {
//     let newTableau = [];
//     tableauImage.forEach((item) => {
//       newTableau.push(item.originFileObj);
//     });
//     return newTableau;
//   };
//   const onPreview = async (file) => {
//     let src = file.url;
//     if (!src) {
//       src = await new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(file.originFileObj);
//         reader.onload = () => resolve(reader.result);
//       });
//     }
//     const image = new Image();
//     image.src = src;
//     const imgWindow = window.open(src);
//     imgWindow?.document.write(image.outerHTML);
//   };
//   const [isLoading, setIsLoading] = useState(false);
//   const [allProprietaire, setAllProprietaire] = useState([]);
//   const [isLoadingAll, setIsLoadingAll] = useState(true);
//   const [allPropriete, setAllPropriete] = useState([]);
//   const [allProprieteFilter, setAllProprieteFilter] = useState([]);
//   const [changeColor, setChangeColor] = useState("Nouveau");
//   const [allClients, setAllClients] = useState([]);

//   const saveNouveauClient = async () => {
//     const formData = new FormData();
//     console.log("saveNouveauClient declencher");
//     formData.append("nom", data.nom);
//     formData.append("prenom", data.prenom);
//     formData.append("role_id", 3);
//     formData.append("phone", data.phone);
//     formData.append("email", data.email);
//     formData.append("password", data.password);
//     const response = await instance.post("users", formData);
//     console.log("response.data.data", response);
//     return response.data;
//   };

//   const saveAncienClient = () => {
//     console.log("saveAncienClient declencher");
//     return data.client_id;
//   };

//   const personContrat = () => {
//     let elemnt = "aprimmo";
//     if (data.is_commission_apporter_affaire) {
//       elemnt = "individual";
//     }
//     if (data.commission_structure) {
//       elemnt = "structure";
//     }
//     if (data.is_commission_apporter_affaire && data.commission_structure) {
//       elemnt = "individual and structure";
//     }
//     return elemnt;
//   };
//   // const resetPropriety=()=>{
//   //    setData({...data,propriety_id:""})
//   //    setData({...data,proprietaire_id:""})
//   //    data.propriety_id = "";
//   //     data.propriety_type_transaction = "";
//   //     data.propriety_libelle = "";
//   //     data.proprietaire_id = "";
//   // }
//   const resetDataAfterCreated = () => {
//     setData({
//       nom: "",
//       prenom: "",
//       role_id: 3,
//       email: "",
//       phone: "",
//       password: "00000",
//       client_id: "",
//       proprietaire_id: "",
//       nombre_mois_caution: "",
//       nombre_mois_avance: "",
//       propriety_id: "",
//       propriety_libelle: "",
//       date_entree: "",
//       date_sortie: "",
//       commission_structure: false,
//       is_commission_apporter_affaire: false,
//       propriety_type_transaction: "",
//       commission_introducteur: "",
//       project_percentage: "",
//       commission_montant_terrain_km2: "",
//       frequence_paiement: "mois",
//     });
//   };
//   const sendDataIfConditionFull = async (dataForCreatedNewClient) => {
//     console.log("sendDataIfConditionFull", dataForCreatedNewClient);

//     const introducer_type = personContrat();
//     const formData = new FormData();
//     const tableauImage = convertirGalerie(fileList);
//     for (const element in tableauImage) {
//       formData.append("path[]", tableauImage[element]);
//     }
//     formData.append("proprietaire_id", data.proprietaire_id);
//     formData.append(
//       "client_id",
//       changeColor === "Nouveau"
//         ? Number(dataForCreatedNewClient?.data.id)
//         : Number(dataForCreatedNewClient)
//     );
//     formData.append("propriety_id", data.propriety_id);
//     formData.append("date_entree", data.date_entree);
//     formData.append("date_sortie", data.date_sortie);
//     formData.append("nombre_mois_caution", data.nombre_mois_caution);
//     formData.append("nombre_mois_avance", data.nombre_mois_avance);
//     formData.append("introducer_type", introducer_type);
//     formData.append("frequence_paiement", data.frequence_paiement);
//     formData.append("project_percentage", data.project_percentage);
//     formData.append("commission_introducteur", data.commission_introducteur);
//     formData.append("commission_structure", data.commission_structure ? 50 : 0);
//     formData.append(
//       "commission_montant_terrain_km2",
//       data.commission_montant_terrain_km2
//     );

//     const response = await instance.post("/contracts", formData);
//     console.log("CONTART contracts25", response);
//     if (response?.data.status === false) {
//       let msgError = [];
//       for (const property in response?.data.message) {
//         msgError = [...msgError, response?.data.message[property]];
//       }
//       MySwal.fire({
//         title: msgError,
//         icon: "info",
//         showConfirmButton: true,
//       });
//       setIsLoading(false);
//     } else {
//       // resetPropriety()
//       setIsLoading(false);
//       resetDataAfterCreated();
//       onChangeForGalerie({ fileList: [] });
//       MySwal.fire({
//         title: "Enregistrement reussi.",
//         icon: "success",
//         showConfirmButton: false,
//         timer: 1500,
//       });
//     }
//   };
//   const saveContrat = async (e) => {
//     e.preventDefault();
//     // dispatch(handleTogglePrintContrat(true));
//     console.log("changeColor", changeColor);
//     setIsLoading(true);
//     try {
//       const dataForCreatedNewClient =
//         changeColor === "Nouveau"
//           ? await saveNouveauClient()
//           : saveAncienClient();
//       console.log("dataForCreatedNewClient", dataForCreatedNewClient);
//       if (!dataForCreatedNewClient.status) {
//         let msgError = [];
//         for (const property in dataForCreatedNewClient.message) {
//           msgError = [...msgError, dataForCreatedNewClient.message[property]];
//         }
//         MySwal.fire({
//           title: msgError,
//           icon: "info",
//           showConfirmButton: true,
//         });
//         setIsLoading(false);
//       } else {
//         await sendDataIfConditionFull(dataForCreatedNewClient);
//       }
//     } catch (error) {
//       console.log(error);
//       let msgError = [];
//       for (const property in error.response?.data.message) {
//         msgError = [...msgError, error.response?.data.message[property]];
//       }
//       MySwal.fire({
//         title: msgError,
//         icon: "info",
//         showConfirmButton: true,
//       });
//       setIsLoading(false);
//     }
//   };
//   function functionChangeColor(value) {
//     setChangeColor(value);
//   }
//   const getCategorie = (proprietyId) => {
//     const propriete = allPropriete.find(
//       (item) => Number(item.id) === Number(proprietyId)
//     );

//     if (!propriete) {
//       console.warn("Propriété introuvable :", proprietyId);
//       return;
//     }

//     const label = propriete?.type?.category?.label || "";
//     const typeTransaction = propriete?.type_de_transaction || "";

//     setData((prev) => ({
//       ...prev,
//       propriety_id: proprietyId,
//       propriety_libelle: label,
//       propriety_type_transaction: typeTransaction.toUpperCase().trim(), // Normalisation
//     }));

//     console.log("🏠 Type transaction :", typeTransaction);
//     console.log("🏷️ Libellé propriété :", label);
//   };
//   // const getCategorie = (element) => {
//   //   const {
//   //     type: {
//   //       category: { label },
//   //     },
//   //     type_de_transaction,
//   //   } = allPropriete.find((item) => Number(item.id) === Number(element));
//   //   console.log("getCategorietype_de_transaction", type_de_transaction);
//   //   console.log("getCategorie label", label);
//   //   data.propriety_id = element;
//   //   setData({ ...data, propriety_type_transaction: type_de_transaction });
//   //   setData({ ...data, propriety_libelle: label });
//   //   console.log("8548", data.propriety_type_transaction);
//   // };
//   const listerAll = async () => {
//     const response = await instance.get("prorietaires");
//     const responsePropriete = await instance.get("proprieties");
//     const responseClients = await instance.get("clients");
//     setAllProprietaire(response?.data.data);
//     setAllClients(responseClients?.data.data);
//     setAllPropriete(responsePropriete?.data.data);
//     setIsLoadingAll(false);
//   };
//   useEffect(() => {
//     listerAll();
//   }, []);

//   if (isLoadingAll) return <LoadingSpinner />;

//   return (
//     <div>
//       <PrintModalContrat />
//       <Header libelle={"Enregistrer un contrat"} />
//       <form onSubmit={saveContrat} className="px-3 my-3">
//         <div
//           className="d-flex justify-content-center align-items-center
//         gap-3"
//           style={{
//             padding: ".3em",
//             background: "#bfc3c7",
//             borderRadius: "5px",
//             width: "300px",
//             margin: "0 auto",
//           }}>
//           <span
//             style={{
//               background: changeColor === "Nouveau" ? "white" : "transparent",
//               color: changeColor === "Nouveau" ? "black" : "white",
//               padding: ".2em",
//               cursor: "pointer",
//               borderRadius: "5px",
//             }}
//             onClick={() => functionChangeColor("Nouveau")}>
//             Nouveau client
//           </span>
//           <span
//             style={{
//               background: changeColor !== "Nouveau" ? "white" : "transparent",
//               color: changeColor !== "Nouveau" ? "black" : "white",
//               padding: ".2em",
//               cursor: "pointer",
//               borderRadius: "5px",
//             }}
//             onClick={() => functionChangeColor("Ancien")}>
//             Ancien client
//           </span>
//         </div>
//         <div>
//           <label htmlFor="profil">Propriétaires</label>
//           <select
//             name="profil"
//             id="all_proprietaire"
//             defaultValue={data.proprietaire_id}
//             onChange={(e) => {
//               setData({ ...data, proprietaire_id: e.target.value });
//               const elemnt = allPropriete.filter(
//                 (item) =>
//                   Number(item.proprietaire_id) === Number(e.target.value)
//               );
//               console.log("elemntFILTER", elemnt);
//               setAllProprieteFilter(elemnt);
//             }}
//             className="w-100 p-3 mb-2">
//             <option value={""} disabled>
//               Sélectionner un proprietaire
//             </option>
//             {allProprietaire.map((item) => (
//               <option key={item.id} value={item.id} className="my-2">
//                 {item.nom} {item.prenom}
//               </option>
//             ))}
//           </select>
//         </div>
//         {/* <AutocompleteData
//           dataList={allProprietaire}
//           libelleLabel={"Propriétaires"}
//         /> */}
//         <div>
//           <label htmlFor="profil">Biens</label>
//           <select
//             name="profil"
//             defaultValue={data.propriety_id}
//             id="all_categorie"
//             onChange={(e) => {
//               console.log("all_categorie", e.target.value);
//               getCategorie(e.target.value);
//             }}
//             className="w-100 p-3 mb-2">
//             <option value={""} disabled>
//               Sélectionner un bien
//             </option>
//             {allProprieteFilter.map((item) => (
//               <option key={item.id} value={item.id} className="my-2">
//                 {item.nom}
//               </option>
//             ))}
//           </select>
//         </div>

//         {changeColor === "Nouveau" && (
//           <>
//             <InputCreate
//               label="Nom du client"
//               typeInput="text"
//               nameInput="name"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, nom: e.target.value });
//               }}
//               dataValue={data.nom}
//             />
//             <InputCreate
//               label="Prénoms du client"
//               typeInput="text"
//               nameInput="text"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, prenom: e.target.value });
//               }}
//               dataValue={data.prenom}
//             />
//             <InputCreate
//               label="Email du client"
//               typeInput="email"
//               nameInput="email"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, email: e.target.value });
//               }}
//               dataValue={data.email}
//             />
//             <InputCreate
//               label="Téléphone du client"
//               typeInput="phone"
//               nameInput="phone"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, phone: e.target.value });
//               }}
//               dataValue={data.phone}
//             />
//           </>
//         )}
//         {changeColor !== "Nouveau" && (
//           <>
//             <div>
//               <label htmlFor="profil">Clients</label>
//               <select
//                 name="profil"
//                 id="all_categorie"
//                 onChange={(e) => {
//                   setData({ ...data, client_id: e.target.value });
//                 }}
//                 className="w-100 p-3 mb-2">
//                 <option value={""} disabled>
//                   Sélectionner un client
//                 </option>
//                 {allClients.map((item) => (
//                   <option key={item.id} value={item.id} className="my-2">
//                     {item.nom}
//                     {item.prenom}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </>
//         )}

//         {data.propriety_libelle && data.propriety_libelle !== "Terrain" && (
//           <>
//             <InputCreate
//               label={
//                 data.propriety_type_transaction !== "EN VENTE"
//                   ? "Date d'entrée"
//                   : "Début de paiement"
//               }
//               typeInput="date"
//               nameInput="Date d'entrée"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, date_entree: e.target.value });
//               }}
//               dataValue={data.date_entree}
//             />
//             <InputCreate
//               label={
//                 data.propriety_type_transaction !== "EN VENTE"
//                   ? "Date de sortie"
//                   : "Fin de paiement"
//               }
//               typeInput="date"
//               nameInput="Date de sortie"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, date_sortie: e.target.value });
//               }}
//               dataValue={data.date_sortie}
//             />
//             {data.propriety_type_transaction !== "EN VENTE" && (
//               <>
//                 <InputCreate
//                   label="Caution (Nombre de mois)"
//                   typeInput="number"
//                   isRequired={false}
//                   minValueInput={1}
//                   nameInput="caution"
//                   active={false}
//                   getValue={(e) => {
//                     setData({ ...data, nombre_mois_caution: e.target.value });
//                   }}
//                   dataValue={data.nombre_mois_caution}
//                 />

//                 <InputCreate
//                   label="Avance (Nombre de mois)"
//                   typeInput="number"
//                   isRequired={false}
//                   minValueInput={1}
//                   nameInput="avance"
//                   active={false}
//                   getValue={(e) => {
//                     setData({ ...data, nombre_mois_avance: e.target.value });
//                   }}
//                   dataValue={data.nombre_mois_avance}
//                 />
//               </>
//             )}

//             <div>
//               <label htmlFor="paiement_frequence">
//                 Choisir la fréquence de paiement (Mois)
//               </label>
//               <select
//                 name="paiement_frequence"
//                 id="paiement_frequence"
//                 onChange={(e) => {
//                   setData({ ...data, frequence_paiement: e.target.value });
//                 }}
//                 className="w-100 p-3 mb-2">
//                 <option value={""} disabled>
//                   Sélectionner une fréquence
//                 </option>
//                 <option value="mois">1</option>
//                 <option value="2mois">2</option>
//                 <option value="3mois">3</option>
//                 <option value="4mois">4</option>
//                 <option value="6mois">6</option>
//                 <option value="annee">12</option>
//               </select>
//             </div>
//           </>
//         )}

//         <fieldset>
//           <legend className="h6">Commissions</legend>
//           <div>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   onChange={(event) =>
//                     setData({
//                       ...data,
//                       commission_structure: event.target.checked,
//                     })
//                   }
//                 />
//               }
//               label="Partenaires"
//             />
//           </div>
//           <div>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   onChange={(event) =>
//                     setData({
//                       ...data,
//                       is_commission_apporter_affaire: event.target.checked,
//                     })
//                   }
//                 />
//               }
//               label="Apporteur d'affaire"
//             />
//           </div>
//           {data.propriety_libelle && data.propriety_libelle === "Terrain" && (
//             <div>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     onChange={(event) =>
//                       setData({
//                         ...data,
//                         is_commission_by_superfice: event.target.checked,
//                       })
//                     }
//                   />
//                 }
//                 label="Selon la superficie"
//               />
//             </div>
//           )}
//         </fieldset>

//         {/*add commission conditions*/}
//         {data.is_commission_by_superfice && (
//           <InputCreate
//             label="Montant au m2 (Fcfa)"
//             typeInput="number"
//             minValueInput={1}
//             nameInput="Percent"
//             active={true}
//             getValue={(e) => {
//               setData({
//                 ...data,
//                 commission_montant_terrain_km2: e.target.value,
//               });
//             }}
//             dataValue={data.commission_montant_terrain_km2}
//           />
//         )}
//         {data.propriety_libelle === "Maison" &&
//           data.propriety_type_transaction === "EN VENTE" && (
//             <InputCreate
//               label="Pourcentage aprimmo (3% à 5%)"
//               typeInput="number"
//               isRequired={true}
//               minValueInput={3}
//               maxValueInput={5}
//               nameInput="Percent"
//               active={true}
//               getValue={(e) => {
//                 setData({ ...data, project_percentage: e.target.value });
//               }}
//               dataValue={data.project_percentage}
//             />
//           )}
//         {data.is_commission_apporter_affaire && (
//           <InputCreate
//             label="Commission apporteur affaire (30% à 40%)"
//             typeInput="number"
//             isRequired={false}
//             nameInput="Commission_apporteur"
//             active={true}
//             getValue={(e) => {
//               setData({ ...data, commission_introducteur: e.target.value });
//             }}
//             dataValue={data.commission_introducteur}
//           />
//         )}

//         <section className="my-1">
//           <label htmlFor="doc" className="my-2">
//             Charger des Documents
//           </label>
//           <Upload
//             listType="picture-card"
//             fileList={fileList}
//             onChange={onChangeForGalerie}
//             onPreview={onPreview}
//             multiple>
//             {fileList.length < 5 && "+ Charger vos documents"}
//           </Upload>
//         </section>
//         <div>
//           <Button
//             titre="Enregistrer"
//             styleBtn={styleBtn}
//             isLoading={isLoading}
//           />
//         </div>
//       </form>
//     </div>
//   );
// }

// export default CreateContrat;

import React, { useEffect, useState } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Button from "../../features/Button";
import { LoadingSpinner, Header } from "../../shared/compoments";
import { Upload } from "antd";
import PrintModalContrat from "./feature/PrintContrat";

import { useDispatch } from "react-redux";
import { handleTogglePrintContrat } from "../../store/slice/contrat/Contrat.js";

function CreateContrat() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);

  const [data, setData] = useState({
    nom: "",
    prenom: "",
    role_id: 3,
    email: "",
    phone: "",
    password: "00000",
    client_id: "",
    proprietaire_id: "",
    nombre_mois_caution: "",
    nombre_mois_avance: "",
    propriety_id: "",
    propriety_libelle: "",
    date_entree: "",
    date_sortie: "",
    commission_structure: false,
    is_commission_apporter_affaire: false,
    frequence_paiement: "mois",
    propriety_type_transaction: "",
    commission_introducteur: "",
    project_percentage: "",
    commission_montant_terrain_km2: "",
  });
  const [fileList, setFileList] = useState([]);

  const onChangeForGalerie = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    const newTableau = convertirGalerie(newFileList);
    console.log("newTableau", newTableau);
  };
  const convertirGalerie = (tableauImage) => {
    let newTableau = [];
    tableauImage.forEach((item) => {
      newTableau.push(item.originFileObj);
    });
    return newTableau;
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [allProprietaire, setAllProprietaire] = useState([]);
  const [isLoadingAll, setIsLoadingAll] = useState(true);
  const [allPropriete, setAllPropriete] = useState([]);
  const [allProprieteFilter, setAllProprieteFilter] = useState([]);
  const [changeColor, setChangeColor] = useState("Nouveau");
  const [allClients, setAllClients] = useState([]);

  const saveNouveauClient = async () => {
    const formData = new FormData();
    formData.append("nom", data.nom);
    formData.append("prenom", data.prenom);
    formData.append("role_id", 3);
    formData.append("phone", data.phone);
    formData.append("email", data.email);
    formData.append("password", data.password);
    const response = await instance.post("users", formData);
    return response.data;
  };

  const saveAncienClient = () => {
    return data.client_id;
  };

  const personContrat = () => {
    let elemnt = "aprimmo";
    if (data.is_commission_apporter_affaire) {
      elemnt = "individual";
    }
    if (data.commission_structure) {
      elemnt = "structure";
    }
    if (data.is_commission_apporter_affaire && data.commission_structure) {
      elemnt = "individual and structure";
    }
    return elemnt;
  };

  const resetDataAfterCreated = () => {
    setData({
      nom: "",
      prenom: "",
      role_id: 3,
      email: "",
      phone: "",
      password: "00000",
      client_id: "",
      proprietaire_id: "",
      nombre_mois_caution: "",
      nombre_mois_avance: "",
      propriety_id: "",
      propriety_libelle: "",
      date_entree: "",
      date_sortie: "",
      commission_structure: false,
      is_commission_apporter_affaire: false,
      propriety_type_transaction: "",
      commission_introducteur: "",
      project_percentage: "",
      commission_montant_terrain_km2: "",
      frequence_paiement: "mois",
    });
  };

  const sendDataIfConditionFull = async (dataForCreatedNewClient) => {
    const introducer_type = personContrat();
    const formData = new FormData();
    const tableauImage = convertirGalerie(fileList);
    for (const element in tableauImage) {
      formData.append("path[]", tableauImage[element]);
    }
    formData.append("proprietaire_id", data.proprietaire_id);
    formData.append(
      "client_id",
      changeColor === "Nouveau"
        ? Number(dataForCreatedNewClient?.data.id)
        : Number(dataForCreatedNewClient)
    );
    formData.append("propriety_id", data.propriety_id);
    formData.append("date_entree", data.date_entree);
    formData.append("date_sortie", data.date_sortie);
    formData.append("nombre_mois_caution", data.nombre_mois_caution);
    formData.append("nombre_mois_avance", data.nombre_mois_avance);
    formData.append("introducer_type", introducer_type);
    formData.append("frequence_paiement", data.frequence_paiement);
    formData.append("project_percentage", data.project_percentage);
    formData.append("commission_introducteur", data.commission_introducteur);
    formData.append("commission_structure", data.commission_structure ? 50 : 0);
    formData.append(
      "commission_montant_terrain_km2",
      data.commission_montant_terrain_km2
    );

    const response = await instance.post("/contracts", formData);
    if (response?.data.status === false) {
      let msgError = [];
      for (const property in response?.data.message) {
        msgError = [...msgError, response?.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      resetDataAfterCreated();
      onChangeForGalerie({ fileList: [] });
      MySwal.fire({
        title: "Enregistrement réussi.",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const saveContrat = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const dataForCreatedNewClient =
        changeColor === "Nouveau"
          ? await saveNouveauClient()
          : saveAncienClient();
      if (!dataForCreatedNewClient.status) {
        let msgError = [];
        for (const property in dataForCreatedNewClient.message) {
          msgError = [...msgError, dataForCreatedNewClient.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        await sendDataIfConditionFull(dataForCreatedNewClient);
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response?.data.message) {
        msgError = [...msgError, error.response?.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };

  function functionChangeColor(value) {
    setChangeColor(value);
  }

  const getCategorie = (proprietyId) => {
    const propriete = allPropriete.find(
      (item) => Number(item.id) === Number(proprietyId)
    );

    if (!propriete) {
      console.warn("Propriété introuvable :", proprietyId);
      return;
    }

    const label = propriete?.type?.category?.label || "";
    const typeTransaction = propriete?.type_de_transaction || "";

    setData((prev) => ({
      ...prev,
      propriety_id: proprietyId,
      propriety_libelle: label,
      propriety_type_transaction: typeTransaction.toUpperCase().trim(),
    }));
  };

  const listerAll = async () => {
    const response = await instance.get("prorietaires");
    const responsePropriete = await instance.get("proprieties");
    const responseClients = await instance.get("clients");
    setAllProprietaire(response?.data.data);
    setAllClients(responseClients?.data.data);
    setAllPropriete(responsePropriete?.data.data);
    setIsLoadingAll(false);
  };

  useEffect(() => {
    listerAll();
  }, []);

  if (isLoadingAll) return <LoadingSpinner />;

  return (
    <div>
      <PrintModalContrat />
      <Header libelle={"Enregistrer un contrat"} />
      <form onSubmit={saveContrat} className="px-3 my-3">
        {/* Toggle Nouveau / Ancien */}
        <div
          className="d-flex justify-content-center align-items-center gap-3 mb-4"
          style={{
            padding: ".3em",
            background: "#bfc3c7",
            borderRadius: "5px",
            width: "300px",
            margin: "0 auto",
          }}>
          <span
            style={{
              background: changeColor === "Nouveau" ? "white" : "transparent",
              color: changeColor === "Nouveau" ? "black" : "white",
              padding: ".2em .5em",
              cursor: "pointer",
              borderRadius: "5px",
            }}
            onClick={() => functionChangeColor("Nouveau")}>
            Nouveau client
          </span>
          <span
            style={{
              background: changeColor !== "Nouveau" ? "white" : "transparent",
              color: changeColor !== "Nouveau" ? "black" : "white",
              padding: ".2em .5em",
              cursor: "pointer",
              borderRadius: "5px",
            }}
            onClick={() => functionChangeColor("Ancien")}>
            Ancien client
          </span>
        </div>

        {/* Grille Bootstrap */}
        <div className="row">
          {/* Propriétaire */}
          <div className="col-lg-4 mb-3">
            <label htmlFor="all_proprietaire">Propriétaires</label>
            <select
              name="profil"
              id="all_proprietaire"
              defaultValue={data.proprietaire_id}
              onChange={(e) => {
                setData({ ...data, proprietaire_id: e.target.value });
                const elemnt = allPropriete.filter(
                  (item) =>
                    Number(item.proprietaire_id) === Number(e.target.value)
                );
                setAllProprieteFilter(elemnt);
              }}
              className="form-select">
              <option value="" disabled>
                Sélectionner un propriétaire
              </option>
              {allProprietaire.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.nom} {item.prenom}
                </option>
              ))}
            </select>
          </div>

          {/* Bien */}
          <div className="col-lg-4 mb-3">
            <label htmlFor="all_categorie">Biens</label>
            <select
              name="profil"
              id="all_categorie"
              defaultValue={data.propriety_id}
              onChange={(e) => getCategorie(e.target.value)}
              className="form-select">
              <option value="" disabled>
                Sélectionner un bien
              </option>
              {allProprieteFilter.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.nom}
                </option>
              ))}
            </select>
          </div>

          {/* Client selon type */}
          {changeColor === "Nouveau" ? (
            <>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label="Nom du client"
                  typeInput="text"
                  nameInput="name"
                  active={true}
                  getValue={(e) => setData({ ...data, nom: e.target.value })}
                  dataValue={data.nom}
                />
              </div>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label="Prénoms du client"
                  typeInput="text"
                  nameInput="prenom"
                  active={true}
                  getValue={(e) => setData({ ...data, prenom: e.target.value })}
                  dataValue={data.prenom}
                />
              </div>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label="Email du client"
                  typeInput="email"
                  nameInput="email"
                  active={true}
                  getValue={(e) => setData({ ...data, email: e.target.value })}
                  dataValue={data.email}
                />
              </div>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label="Téléphone du client"
                  typeInput="tel"
                  nameInput="phone"
                  active={true}
                  getValue={(e) => setData({ ...data, phone: e.target.value })}
                  dataValue={data.phone}
                />
              </div>
            </>
          ) : (
            <div className="col-lg-4 mb-3">
              <label htmlFor="all_clients">Clients</label>
              <select
                name="profil"
                id="all_clients"
                onChange={(e) =>
                  setData({ ...data, client_id: e.target.value })
                }
                className="form-select">
                <option value="" disabled>
                  Sélectionner un client
                </option>
                {allClients.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nom} {item.prenom}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Champs conditionnels selon type de bien */}
          {data.propriety_libelle && data.propriety_libelle !== "Terrain" && (
            <>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label={
                    data.propriety_type_transaction !== "EN VENTE"
                      ? "Date d'entrée"
                      : "Début de paiement"
                  }
                  typeInput="date"
                  nameInput="date_entree"
                  active={true}
                  getValue={(e) =>
                    setData({ ...data, date_entree: e.target.value })
                  }
                  dataValue={data.date_entree}
                />
              </div>
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label={
                    data.propriety_type_transaction !== "EN VENTE"
                      ? "Date de sortie"
                      : "Fin de paiement"
                  }
                  typeInput="date"
                  nameInput="date_sortie"
                  active={true}
                  getValue={(e) =>
                    setData({ ...data, date_sortie: e.target.value })
                  }
                  dataValue={data.date_sortie}
                />
              </div>

              {data.propriety_type_transaction !== "EN VENTE" && (
                <>
                  <div className="col-lg-4 mb-3">
                    <InputCreate
                      label="Caution (Nombre de mois)"
                      typeInput="number"
                      isRequired={false}
                      minValueInput={1}
                      nameInput="caution"
                      active={false}
                      getValue={(e) =>
                        setData({
                          ...data,
                          nombre_mois_caution: e.target.value,
                        })
                      }
                      dataValue={data.nombre_mois_caution}
                    />
                  </div>
                  <div className="col-lg-4 mb-3">
                    <InputCreate
                      label="Avance (Nombre de mois)"
                      typeInput="number"
                      isRequired={false}
                      minValueInput={1}
                      nameInput="avance"
                      active={false}
                      getValue={(e) =>
                        setData({ ...data, nombre_mois_avance: e.target.value })
                      }
                      dataValue={data.nombre_mois_avance}
                    />
                  </div>
                </>
              )}

              <div className="col-lg-4 mb-3">
                <label htmlFor="paiement_frequence">
                  Fréquence de paiement
                </label>
                <select
                  name="paiement_frequence"
                  id="paiement_frequence"
                  onChange={(e) =>
                    setData({ ...data, frequence_paiement: e.target.value })
                  }
                  className="form-select">
                  <option value="" disabled>
                    Sélectionner une fréquence
                  </option>
                  <option value="mois">1 mois</option>
                  <option value="2mois">2 mois</option>
                  <option value="3mois">3 mois</option>
                  <option value="4mois">4 mois</option>
                  <option value="6mois">6 mois</option>
                  <option value="annee">12 mois</option>
                </select>
              </div>
            </>
          )}

          {/* Commissions */}
          <div className="col-12 mt-4">
            <fieldset>
              <legend className="h6">Commissions</legend>
              <div className="row">
                <div className="col-lg-4">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) =>
                          setData({
                            ...data,
                            commission_structure: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Partenaires"
                  />
                </div>
                <div className="col-lg-4">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) =>
                          setData({
                            ...data,
                            is_commission_apporter_affaire: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Apporteur d'affaire"
                  />
                </div>
                {data.propriety_libelle === "Terrain" && (
                  <div className="col-lg-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) =>
                            setData({
                              ...data,
                              is_commission_by_superfice: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Selon la superficie"
                    />
                  </div>
                )}
              </div>
            </fieldset>
          </div>

          {/* Champs commissions conditionnels */}
          {data.is_commission_by_superfice && (
            <div className="col-lg-4 mb-3">
              <InputCreate
                label="Montant au m² (Fcfa)"
                typeInput="number"
                minValueInput={1}
                nameInput="commission_m2"
                active={true}
                getValue={(e) =>
                  setData({
                    ...data,
                    commission_montant_terrain_km2: e.target.value,
                  })
                }
                dataValue={data.commission_montant_terrain_km2}
              />
            </div>
          )}

          {data.propriety_libelle === "Maison" &&
            data.propriety_type_transaction === "EN VENTE" && (
              <div className="col-lg-4 mb-3">
                <InputCreate
                  label="Pourcentage aprimmo (3% à 5%)"
                  typeInput="number"
                  isRequired={true}
                  minValueInput={3}
                  maxValueInput={5}
                  nameInput="percent_aprimmo"
                  active={true}
                  getValue={(e) =>
                    setData({ ...data, project_percentage: e.target.value })
                  }
                  dataValue={data.project_percentage}
                />
              </div>
            )}

          {data.is_commission_apporter_affaire && (
            <div className="col-lg-4 mb-3">
              <InputCreate
                label="Commission apporteur (30% à 40%)"
                typeInput="number"
                isRequired={false}
                nameInput="commission_apporteur"
                active={true}
                getValue={(e) =>
                  setData({ ...data, commission_introducteur: e.target.value })
                }
                dataValue={data.commission_introducteur}
              />
            </div>
          )}
        </div>

        {/* Upload de documents */}
        <section className="my-4">
          <label className="form-label">Charger des Documents</label>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onChange={onChangeForGalerie}
            onPreview={onPreview}
            multiple>
            {fileList.length < 5 && "+ Charger vos documents"}
          </Upload>
        </section>

        {/* Bouton submit */}
        <div className="text-center">
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
}

export default CreateContrat;
